namespace Client.Components

open Fable.FontAwesome
open Fable.React
open Fulma


[<RequireQualifiedAccess>]
module Icon =
    let createElement (icon: Fa.IconOption) =
        Icon.icon [ Icon.Size IsSmall; Icon.IsLeft ] [ Fa.i [ icon ] [] ]

    let createWithText (icon: Fa.IconOption) (text: string) =
        Icon.Text.span [] [
            Icon.icon [] [ Fa.i [ icon ] [] ]
            span [] [ str text ]
        ]